import createTableSelectionStore from "ds/components/Table/store/useTableSelectionStore";

const useIntegrationsAiTableSelectionStore = createTableSelectionStore();

export default useIntegrationsAiTableSelectionStore;
